export default "__VITE_ASSET__CxhrwBP0__"